import PopUp from '../../../../Shared/Popup/PopUp';
import React, {useEffect, useState} from 'react';
import {buildUrlAndOpenSameWindow} from '../../../../../utilities/StringHelpers/StringHelpers';
import Config from '../../../../../Config';
import BtnWhiteBlackBorderSmallSize from '../../../../Shared/Buttons/BtnWhiteBlackBorderSmallSize';
import {androidSVG, iosSVG, stageEnums} from '../../Assets/VolteCheckVariables';
import {buildUrlAndOpenWindow} from '../../../../../utilities/StringHelpers/StringHelpers';
import OtpVerificationComponent from '../../../../Shared/OtpAuthentication/OtpVerificationComponent';
import {isMobile} from 'react-device-detect';
import {otpOrigin} from 'app/Components/Block/OTPLoginBlock/Assets/variables';

const OtpStage = (props) => {
  const otpTitles = {
    verifyPhoneTitle: 'מה מספר הטלפון שלך?',
    verifyPhoneDescription: '',
    verifyCodeTitle: 'מה הקוד שקיבלת?',
    verifyCodeDescription: '',
  };

  const disclaimerText = isMobile ? (
    <p className='disclaimerText'>
      *{window.Config.brand_Name_HE} עושה את מירב המאמצים לספק את המידע <br />
      המעודכן והאמין ביותר, אך הוא נועד לנוחות בלבד ואינו <br />
      מובטח כמדויק בכל עת. על מנת לבדוק אם מכשירך מתאים <br />
      ועומד ביכולות דור 4/5, עליך לוודא זאת מול יצרן המכשיר.
    </p>
  ) : (
    <p className='disclaimerText'>
      *{window.Config.brand_Name_HE} עושה את מירב המאמצים לספק את המידע המעודכן והאמין ביותר,
      <br />
      אך הוא נועד לנוחות בלבד ואינו מובטח כמדויק בכל עת. על מנת לבדוק אם <br />
      מכשירך מתאים ועומד ביכולות דור 4/5, עליך לוודא זאת מול יצרן המכשיר.
    </p>
  );

  return (
    <>
      <PopUp
        showPopUp={true}
        onClose={() => {
          history.back();
        }}>
        <OtpVerificationComponent
          otpOrigin={otpOrigin.POPUP}
          originProcess={'Volte'}
          otpTitles={otpTitles}
          onAuthenticatedAction={props.onFinish}
          onRejectedAction={() => {
            props.onFinish(false);
          }}
          isInline={false}
        />
        {!props.otp.ticketId ? disclaimerText : null}
      </PopUp>
    </>
  );
};

export default OtpStage;
